import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApplicationEvent } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { TimelineService } from '@workspace-app/shared/timeline/services/timeline.service';

@Injectable({
  providedIn: 'root',
})
export class ApprovedSystemsTimelineService extends TimelineService {
  constructor() {
    super();
  }

  protected fetchEntityData(_entityType: string, _entityId: string): Observable<{ entity: { notes: unknown[] } }> {
    // Approved systems don't currently have notes, so return empty notes array
    return of({
      entity: {
        notes: [],
      },
    });
  }

  protected override fetchApplicationEvents(entityId: string, entityTypes: string[]): Observable<ApplicationEvent[]> {
    // For approved systems, we query CertifiableSystem events
    // Color-related events use CertifiableSystem entity type (CoatingSystem is a derived type sharing the same ID)
    const approvedSystemTypes = ['CertifiableSystem'];

    // Combine requested entity types with approved system-specific types
    const allTypes = [...new Set([...entityTypes, ...approvedSystemTypes])];

    const typeFilter = allTypes.map((type) => `entityType eq '${type}'`).join(' or ');

    return this.applicationEventsService
      .entities()
      .query((q) => {
        q.filter(`entityId eq ${entityId} and (${typeFilter})`);
        q.orderBy('timestamp desc');
        q.expand('user');
        q.top(500); // Limit to last 500 events for performance
      })
      .fetch()
      .pipe(
        map((response) => response.entities || []),
        catchError((error) => {
          console.error('Failed to fetch approved system application events:', error);
          return of([]);
        })
      );
  }
}
